import "E:\\workspace\\ysorder\\order_admin_client\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\workspace\\ysorder\\order_admin_client\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\workspace\\ysorder\\order_admin_client\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\workspace\\ysorder\\order_admin_client\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import App from './App.vue';
import { initRouter } from './router';
import './theme/index.less';
import Antd from 'ant-design-vue';
import Viser from 'viser-vue';
import store from './store';
import 'animate.css/source/animate.css';
import Plugins from '@/plugins';
import { initI18n } from '@/utils/i18n';
import bootstrap from '@/bootstrap';
import 'moment/locale/zh-cn';
import MetaInfo from 'vue-meta';
import _ from 'lodash';
import * as filters from './filters'; // global filters

var router = initRouter(store.state.setting.asyncRoutes);
var i18n = initI18n('CN', 'US');
Vue.use(Antd);
Vue.config.productionTip = false;
Vue.use(Viser);
Vue.use(Plugins);
Vue.use(MetaInfo);
Vue.prototype._ = _;
import { Modal, message } from 'ant-design-vue';
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;
Vue.prototype.$message = message;

// 组件通信
Vue.prototype.$bus = new Vue();

// 新统一样式弹出层
import dialog from './system-components/dialog/dialog.vue';
Vue.component('design-dialog', dialog);

// pixel 转 rem
Vue.prototype.$px2rem = function () {
  var pixel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return pixel / 75 + 'rem';
};

// register global utility filters.
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
bootstrap({
  router: router,
  store: store,
  i18n: i18n,
  message: Vue.prototype.$message,
  notification: Vue.prototype.$notification
});

// 装修页面引入pc_clinet中的代码

Vue.prototype.$formatMoney = function (number, places, symbolL, symbolR, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbolL = symbolL !== undefined ? symbolL : "";
  symbolR = symbolR !== undefined ? symbolR : "";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbolL + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "" + symbolR);
};
Vue.prototype.$checkPrice = function (num) {
  var rightCurrencySymbol = localStorage.rightCurrencySymbol,
    leftCurrencySymbol = localStorage.leftCurrencySymbol;
  num = num || 0;
  return "<d class='leftPart'>" + leftCurrencySymbol + Vue.prototype.$formatMoney(num, 0) + "</d><d class='rightPart'>" + rightCurrencySymbol + "</d>";
};
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');